const API_BASE = process.env.REACT_APP_CONTACT_API_URL || '';

export interface ContactFormData {
  name: string;
  email: string;
  topic: string;
  message: string;
  _honeypot?: string;
}

export async function sendPublicContactForm(data: ContactFormData): Promise<void> {
  const response = await fetch(`${API_BASE}/public`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body.error || `Request failed: ${response.status}`);
  }
}

export async function sendAuthenticatedContactForm(data: ContactFormData): Promise<void> {
  const { fetchAuthSession } = await import('aws-amplify/auth');
  const session = await fetchAuthSession();
  const token = session.tokens?.idToken?.toString();
  if (!token) throw new Error('Not authenticated');

  const response = await fetch(`${API_BASE}/authenticated`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  });
  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body.error || `Request failed: ${response.status}`);
  }
}
